<template>
  <div class="monitoring-cabin-container">
    <v-in-out-search name="发退卡信息查询"></v-in-out-search>
    <el-tabs v-model="tabsName" @tab-click="gotoOtherPage">
      <el-tab-pane label="最新进出场人员" name="first">
        <div class="table-prefix-box">
          <div class="btn-box">
            <el-button-group class="mr-10">
              <el-button @click="download" size="mini" type="primary" icon="el-icon-download">导出
              </el-button>
            </el-button-group>
          </div>
          <div class="search-box mt-15"></div>
        </div>

        <div class="table mt-15">
          <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
            @current-change="handleCurrentChange" style="width:100%">
            <el-table-column label="工号" property="id"></el-table-column>
            <el-table-column label="姓名"></el-table-column>
            <el-table-column label="部门"></el-table-column>
            <el-table-column label="刷卡地点"></el-table-column>
            <el-table-column label="刷卡时间"></el-table-column>
            <el-table-column label="退卡地点"></el-table-column>
            <el-table-column label="退卡时间"></el-table-column>
          </el-table>
        </div>

        <div class="pagination pt-10 t-center">
          <el-pagination background layout="total,sizes,prev,pager,next,jumper"
            :page-size="pagination.size" :page-sizes="[10,20,30,50]"
            :current-page.sync="pagination.page" :total="pagination.total" @size-change="changeSize"
            @current-change="changeCurrent"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="通讯异常报警" name="second">
        <div class="table-prefix-box">
          <div class="btn-box">
            <el-button-group class="mr-10">
              <el-button @click="download" size="mini" type="primary" icon="el-icon-download">导出
              </el-button>
            </el-button-group>
          </div>
          <div class="search-box mt-15"></div>
        </div>
        <div class="table mt-15">
          <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
            @current-change="handleCurrentChange" style="width:100%">
            <el-table-column label="工号" property="id"></el-table-column>
            <el-table-column label="字段待定"></el-table-column>
            <el-table-column label="字段待定"></el-table-column>
            <el-table-column label="字段待定"></el-table-column>
            <el-table-column label="字段待定"></el-table-column>
            <el-table-column label="字段待定"></el-table-column>
            <el-table-column label="字段待定"></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script type="text/ecmascript-6">
import { tool } from "../../common/js/tool.js";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      tabsName: "first",
      obj: {
        txt: "",
        txt11: "",
        select: "",
        select11: "",
        date: "",
        datas: "",
        dateTime: "",
        number: ""
      },
      list: [],
      currentRow: null,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      tableLoading: false,
      addobj: { name: "" },
      addDialogShow: false
    };
  },

  computed: {},

  created() {
    this.getData();
  },

  methods: {
    gotoOtherPage() {},
    download() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "数据生成中"
      });
      setTimeout(() => {
        loadingInstance.close();
      }, 1000);
    },
    clickAdd() {
      this.addDialogShow = true;
      this.currentRow = null;
    },
    clickEdit() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
        return;
      }
      this.addDialogShow = true;
    },
    del() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
      } else {
        this.$confirm("确定要删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$message({
            type: "success",
            duration: 1000,
            message: "操作成功!",
            onClose: () => {
              this.getData();
            }
          });
        });
      }
    },
    submit() {
      console.log(this.addobj);
      this.addDialogShow = false;
    },
    getData(flag) {
      let obj = Object.assign({}, this.obj);
      obj.page = flag ? this.pagination.page : 1;
      this.pagination.page = flag ? this.pagination.page : 1;
      console.log(this.obj, this.pagination, obj);
      this.tableLoading = true;
      setTimeout(() => {
        this.tableLoading = false;
        this.pagination.total = 222;
        this.list = [
          { id: 1 },
          { id: 2 },
          { id: 3 },
          { id: 4 },
          { id: 5 },
          { id: 6 },
          { id: 7 },
          { id: 8 },
          { id: 9 },
          { id: 10 }
        ];
      }, 10);
    },
    reset() {
      this.obj.page = 1;
      this.pagination.page = 1;
      this.getData();
    },
    changeCurrent(val) {
      this.pagination.page = val;
      this.obj.page = val;
      this.getData(true);
    },

    changeSize(e) {
      this.pagination.size = e;
      this.obj.pageSize = e;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      //console.log(val.id);
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
.monitoring-cabin-container {
  width: 100%;
  height: auto;
  display: flex;
  align-items: stretch;
  padding: 15px;
  flex-direction: column;
}
</style>
